import styled from 'styled-components';
import bg from '../../assets/images/weather_bg.png';

const StyledContainer = styled.div`
	position: relative;
	width: 150px;
	height: 170px;
	padding: 20px;
	border-radius: 20px;
	overflow: hidden;
	grid-column: span 2;
	grid-row: span 2;
	background-image: url(${bg});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledBottomCircles = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 20px;
	display: flex;
	gap: 10px;
`;

const StyledCircle = styled.div<{ $active?: boolean }>`
	width: 6px;
	height: 6px;
	border-radius: 6px;
	background-color: #ffffff;
	opacity: ${({ $active }) => ($active ? 1 : 0.25)};
`;

export { StyledBottomCircles, StyledCircle, StyledContainer };
